import React, { Component } from "react";
import LayoutBackoffice from "../header_footer/LayoutBackoffice";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import axios from "axios";
import PropTypes from "prop-types";

const myStyle = {
  float: "right"
};

class PontosInteresse extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      pontosInteresse: []
    };
  }

  componentDidMount = () => {
    this.loadPontos();
  };

  loadPontos = async () => {

    let res = {};
    try {
      res = await axios.get("/api/pontosInteresse", {
        params: {
          'type': "PONTO_INTERESSE",
          'limit': 0
        },
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.log(error);
    }

    let pontosInteresse = res.data.arrayPontos;

    this.setState({ pontosInteresse: pontosInteresse });
  };

  rowClicked = identifier => {
    this.context.router.history.push(
      "/backoffice/pontos_interesse/" + identifier
    );
  };

  addButtonClicked = () => {
    this.context.router.history.push(
      "/backoffice/pontos_interesse/adicionar"
    );
  }

  render() {

    const items = this.state.pontosInteresse.map(
      function(item) {
        return (
          <TableRow
            onClick={() => this.rowClicked(item.identifier)}
            key={item.identifier}
          >
            <TableCell>{item.name}</TableCell>
            <TableCell>
              <i style={myStyle} className="fas fa-arrow-right" />
            </TableCell>
          </TableRow>
        );
      }.bind(this)
    );

    return (
      <LayoutBackoffice>
        <div className="container">
          <div className="row">
            <div className="div-btn">
              <button
                type="button"
                className="backoffice-btn btn btn-outline-info"
                onClick={this.addButtonClicked}
              >
                Adicionar
              </button>
            </div>
            <Table className="backoffice-table">
              <TableHead className="table-header">
                <TableRow>
                  <TableCell>Nome</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>{items}</TableBody>
            </Table>
          </div>
        </div>
      </LayoutBackoffice>
    );
  }
}

export default PontosInteresse;
